import { Icon, StarMark } from "@core/icons";
import type { StoredValidatorSession } from "../access/session";
import "./home.css";

// Adaptación de `Cabecera` (`validador.jsx:235-247`). El lugar no es
// seleccionable (RF-VAL-11, SPEC-302 §2, criterio 1): no hay ningún control
// interactivo sobre `placeName`/`placeCity`, solo texto.
export function SessionHeader({
  session,
  onSignOut,
  signingOut,
}: {
  session: StoredValidatorSession;
  onSignOut: () => void;
  signingOut: boolean;
}) {
  return (
    <div className="sc-header">
      <StarMark size={30} ring stroke={1} />
      <div className="sc-header-info">
        <div className="sc-header-name">{session.placeName}</div>
        <div className="sc-header-sub">
          {session.userName}
          {session.placeCity ? ` · ${session.placeCity}` : ""}
        </div>
      </div>
      <button
        type="button"
        onClick={onSignOut}
        disabled={signingOut}
        className="sc-header-exit"
      >
        <Icon name="logout" size={17} stroke={1.7} />
        Salir
      </button>
    </div>
  );
}
